<template>
    <div class="dialog_section dialog_height">
        <div class="table_box">
            <div v-if="detailType === 'offline' || detailType === 'pulledOut'" class="table_toolbar">
                <el-button type="primary" size="small" icon="el-icon-download" :loading="downloadLoading" :disabled="!totalPage" @click="downloadDetail">下载</el-button>
            </div>
            <el-table ref="multipleTable" :data="tableData" height="520" border v-loading="loading">
                <el-table-column label="序号" type="index" width="60"></el-table-column>
                <el-table-column prop="subTenantName" label="运营公司" min-width="150"></el-table-column>
                <el-table-column prop="plateNo" label="车牌号" min-width="120"></el-table-column>
                <el-table-column prop="deviceNumber" label="设备号" min-width="140"></el-table-column>
                <el-table-column prop="onlineStatusText" label="在线状态" min-width="100"></el-table-column>
                <el-table-column prop="pluggingStatusText" label="插拔状态" min-width="100"></el-table-column>
                <el-table-column v-if="detailType === 'online'" prop="lastDataTime" label="最近定位时间" min-width="170"></el-table-column>
                <el-table-column v-if="detailType === 'offline'" prop="offlineTime" label="离线时间" min-width="170"></el-table-column>
                <el-table-column v-if="detailType === 'offline'" prop="offlineReason" label="离线原因" min-width="140"></el-table-column>
                <el-table-column v-if="detailType === 'offline'" prop="lastDataTime" label="最近定位时间" min-width="170"></el-table-column>
                <el-table-column v-if="detailType === 'pulledOut'" prop="lastPullTime" label="最近拔出时间" min-width="170"></el-table-column>
                <el-table-column v-if="detailType === 'pulledOut'" prop="lastInsertTime" label="最近插入时间" min-width="170"></el-table-column>
                <el-table-column v-if="detailType === 'pulledOut'" prop="lastDataTime" label="最近定位时间" min-width="170"></el-table-column>
                <el-table-column v-if="detailType === 'noTrip7d'" prop="noTripDays" label="最近7天无行程天数" min-width="140"></el-table-column>
                <el-table-column v-if="detailType === 'noTrip7d'" prop="noTripTimeRange" label="最近7天无行程时段" min-width="220"></el-table-column>
                <el-table-column v-if="detailType === 'noTrip7d'" prop="lastTripTime" label="最后行程时间" min-width="170"></el-table-column>
                <el-table-column v-if="detailType === 'noTrip7d'" prop="lastDataTime" label="最近定位时间" min-width="170"></el-table-column>
            </el-table>
            <el-pagination
                style="margin-top: 0.2rem"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                :current-page="currentPage"
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 20]"
                :page-size="pageSize"
                :total="totalPage"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import * as XLSX from 'xlsx';

export default {
    name: 'VehicleDeviceAbnormalDetail',
    props: {
        detailQueryForm: Object,
        detailType: String
    },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            totalPage: 0,
            tableData: [],
            loading: false,
            downloadLoading: false
        };
    },
    mounted() {
        this.getTbodyData();
    },
    methods: {
        getTbodyData() {
            this.loading = true;
            let requestData = {
                condition: this.detailQueryForm,
                pageNo: this.currentPage,
                pageSize: this.pageSize
            };
            this.$request({ method: 'post', url: `/report/api/vehicleDashboard/deviceAbnormalDetail/${this.detailType}`, data: requestData })
                .then((res) => {
                    this.loading = false;
                    if (res.code == 200 && res.data) {
                        this.totalPage = parseInt(res.data.total || 0);
                        this.tableData = (res.data.list || []).map((item) => ({
                            ...item,
                            onlineStatusText: this.getOnlineStatusText(item.onlineStatus),
                            pluggingStatusText: this.getPluggingStatusText(item.pluggingStatus)
                        }));
                    } else {
                        this.totalPage = 0;
                        this.tableData = [];
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.totalPage = 0;
                    this.tableData = [];
                    this.$message.error('接口请求异常，请稍后重试！');
                });
        },
        getOnlineStatusText(val) {
            return val == 1 ? '在线' : val == 2 ? '离线' : '--';
        },
        getPluggingStatusText(val) {
            return val == 1 ? '插入' : val == 2 ? '拔出' : '--';
        },
        downloadDetail() {
            if (!this.totalPage || this.downloadLoading) {
                return;
            }

            this.downloadLoading = true;
            const requestData = {
                condition: JSON.parse(JSON.stringify(this.detailQueryForm)),
                pageNo: 1,
                pageSize: this.totalPage
            };

            this.$request({ method: 'post', url: `/report/api/vehicleDashboard/deviceAbnormalDetail/${this.detailType}`, data: requestData })
                .then((res) => {
                    if (res.code !== 200 || !res.data) {
                        this.$message.error('暂无可下载的数据');
                        return;
                    }

                    const records = (res.data.list || []).map((item) => ({
                        运营公司: item.subTenantName || '--',
                        车牌号: item.plateNo || '--',
                        设备号: item.deviceNumber || '--',
                        在线状态: this.getOnlineStatusText(item.onlineStatus),
                        插拔状态: this.getPluggingStatusText(item.pluggingStatus),
                        ...(this.detailType === 'offline'
                            ? {
                                  离线时间: item.offlineTime || '--',
                                  离线原因: item.offlineReason || '--',
                                  最近定位时间: item.lastDataTime || '--'
                              }
                            : {
                                  最近拔出时间: item.lastPullTime || '--',
                                  最近插入时间: item.lastInsertTime || '--',
                                  最近定位时间: item.lastDataTime || '--'
                              })
                    }));

                    if (!records.length) {
                        this.$message.error('暂无可下载的数据');
                        return;
                    }

                    const worksheet = XLSX.utils.json_to_sheet(records);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, '设备明细');
                    const fileData = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                    const title = this.detailType === 'offline' ? '设备离线明细' : '设备拔出明细';
                    this.$$exportFile(fileData, `${title}.xlsx`);
                })
                .catch(() => {
                    this.$message.error('下载失败，请稍后重试！');
                })
                .finally(() => {
                    this.downloadLoading = false;
                });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getTbodyData();
        },
        handleCurrentChange(val) {
            this.currentPage = Number(val);
            this.getTbodyData();
        }
    }
};
</script>

<style lang="less" scoped>
.table_box {
    width: 100%;
}
.table_toolbar {
    height: 32px;
    margin-bottom: 8px;
    text-align: right;
}
</style>
